<script setup lang="ts">
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import type { CourseBundleTestimonial } from '@/services/interfaces/Course'
  import useBreakpoint from '@/composables/useBreakpoint'
  import AutoSlider from '@/components/common/AutoSlider.vue'

  defineProps<{
    testimonials: CourseBundleTestimonial[]
  }>()

  const { isMobileDevice } = useBreakpoint()
</script>

<template lang="pug">
.full-width-wrapper
  .testimonials-section-wrapper
    .testimonials-section.dashboard-spacing
      .testimonials-slider
        AutoSlider(:items='testimonials', :items-per-slide='isMobileDevice ? 1 : 2', :show-dots='true')
          .testimonial-card(v-for='testimonial in testimonials', :key='testimonial.id')
            .testimonial-image
              img(:src='testimonial.imageUrl', :alt='testimonial.name')
            .testimonial-content
              HTMLRenderer.testimonial-text.h5(:html='testimonial.review', link-target='_blank')
              .author
                span.h5 - {{ testimonial.name }}
                a.h5(
                  v-if='testimonial.externalUrl',
                  :href='testimonial.externalUrl',
                  target='_blank',
                  rel='noopener noreferrer'
                ) , {{ $t('watchVideo') }}
</template>

<style lang="postcss" scoped>
  .testimonials-section-wrapper {
    @apply ketch-w-full ketch-bg-secondary-color ketch-text-secondary-foreground-color ketch-flex ketch-justify-center ketch-mt-c20;

    .testimonials-section {
      .testimonials-slider {
        @apply ketch-relative ketch-overflow-hidden ketch-py-c10 sm:ketch-py-c20;

        .testimonial-card {
          @apply ketch-flex-none ketch-w-full ketch-flex ketch-items-start ketch-gap-c10 ketch-px-c10;
          @apply sm:ketch-gap-c20 sm:ketch-w-1/2;

          .testimonial-image {
            @apply ketch-flex-shrink-0;

            img {
              @apply ketch-w-[40px] ketch-h-[40px] ketch-rounded-full ketch-object-cover;
              @apply sm:ketch-w-[80px] sm:ketch-h-[80px];
            }
          }

          .testimonial-content {
            @apply ketch-flex-1;

            .testimonial-text {
              @apply ketch-mb-c10;
            }

            .author {
              a {
                @apply ketch-underline;
              }
            }
          }
        }
      }
    }
  }
</style>
